const GENERAL_API = process.env.NEXT_PUBLIC_GENERAL_API as string;
const TRAVELER_API = process.env.NEXT_PUBLIC_TRAVELER_API as string;

class APIEndpointsService {
	getRoutes() {
		return {
			airports: {
				get: (id?: string) =>
					id
						? `${GENERAL_API}/airports/v1/${id}`
						: `${GENERAL_API}/airports/v1`,
			},
			availableAircraft: {
				post: () => `${TRAVELER_API}/available-aircraft/search/v1`,
			},
			termsAccept: {
				get: (user_id: string) => `${TRAVELER_API}/terms-accept/v1/${user_id}`,
				post: () => `${TRAVELER_API}/terms-accept/v1`,
			},
			tripReq: {
				get: (id?: string) =>
					id
						? `${GENERAL_API}/trip-reqs/v1/${id}`
						: `${GENERAL_API}/trip-reqs/v1`,
				post: () => `${GENERAL_API}/trip-reqs/v1`,
			},
		};
	}
}

export default APIEndpointsService;
